<template>
  <div id="app">
    <!-- 前台页面显示Header和Footer -->
    <template v-if="!isAdminRoute">
      <Header />
      <main class="main-content">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </main>
      <Footer />
      <FloatingToolbar />
    </template>
    
    <!-- 后台管理页面直接渲染 -->
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script setup>

import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import FloatingToolbar from '@/components/common/FloatingToolbar.vue'
import { useSEO } from '@/composables/useSEO'
import request, { getTenantDomain } from '@/api/request'

const route = useRoute()

// 初始化SEO和域名检查（仅在前台页面）
onMounted(async () => {
  if (!route.path.startsWith('/admin')) {
    useSEO()
    // 检查租户配置的域名，如果不匹配则跳转
    await checkDomainRedirect()
  }
})

// 检查租户绑定的域名并跳转（仅在生产环境生效）
const checkDomainRedirect = async () => {
  // 本地开发环境不跳转域名
  const host = window.location.hostname
  const port = window.location.port
  if (host === 'localhost' || host === '127.0.0.1' || port) {
    return
  }

  try {
    // 发起任意一个API请求，后端会在响应头 X-Tenant-Domain 中返回租户绑定域名
    await request.get('/configs/all')
    
    // 从响应拦截器中获取租户绑定域名（来自 sys_tenant.domain）
    const tenantDomain = getTenantDomain()
    if (tenantDomain && tenantDomain.trim() && tenantDomain.trim() !== host) {
      const targetUrl = `${window.location.protocol}//${tenantDomain.trim()}${window.location.pathname}${window.location.search}`
      console.log(`域名跳转: ${host} -> ${tenantDomain}`)
      window.location.href = targetUrl
    }
  } catch (error) {
    console.error('检查域名跳转失败:', error)
  }
}

// 判断是否为后台管理路由
const isAdminRoute = computed(() => {
  return route.path.startsWith('/admin')
})


// 监听语言变化事件并强制更新组件
window.addEventListener('languageChanged', () => {
  // 通过改变一个响应式数据来触发重新渲染
  if (typeof window.languageVersion !== 'undefined') {
    window.languageVersion++;
  } else {
    window.languageVersion = 1;
  }
});</script>

<style>
@import '@/assets/styles/global.css';

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
}
</style>
